import React, { useState, useEffect } from "react";
import LogoCNC from "../../images/logo-cnc.png";
import LogoAlcaldiaIbague from "../../images/logo-cnc-alcaldiaibague.png";
import ImgVisor1AlcaldiaIbague from "../../images/visor1-AlcaldiaIbague.png";
import ImgVisor2AlcaldiaIbague from "../../images/visor2-AlcaldiaIbague.png";
import { Redirect, Route, Link, useHistory } from "react-router-dom";
import { createTheme, responsiveFontSizes, ThemeProvider } from "@mui/material/styles";
import { AppBar, Button, Card, CardHeader, CardActions, CardContent, Container, Divider, Grid, Toolbar, Typography, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import LogoutIcon from '@mui/icons-material/Logout';

import Sesion from "../Sesion";
import Visor1AlcaldiaIbague from "./Visor1AlcaldiaIbague";
import Visor2AlcaldiaIbague from "./Visor2AlcaldiaIbague";

const Visor1UUID = "039f7ea8-a997-4db8-9e2e-cd349bcb5e9d"
const Visor2UUID = "00b1e9b9-827a-4263-8844-3f9709e5033f"


const buttonColor = (color) => createTheme({
    palette: {
        primary: {
            main: color
        }
    },
    typography: {
        fontFamily: 'Roboto'
    }
});

const useStyles = makeStyles((theme) => ({
    logo: {
        width: 110,
        [theme.breakpoints.up("sm")]: {
            width: 135
        }
    },
    logo2: {
        width: 140,
        [theme.breakpoints.up("sm")]: {
            width: 175
        }
    },
    logoSpacing: {
        marginRight: theme.spacing(1.5),
        [theme.breakpoints.up("sm")]: {
            marginRight: theme.spacing(2)
        },
        display: "flex"
    },
    logoSpacing2: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            marginRight: theme.spacing(4)
        },
        display: "flex"
    },
    username: {
        display: 'none',
        [theme.breakpoints.up("md")]: {
            display: 'unset'
        }
    }
}));

export default function AlcaldiaIbague(props) {
    const { theme, API_DEFAULT, setShowBackdrop, setMessage, setSeverity, setSnack, clientUUID } = props;
    const actualTheme = createTheme(theme, {
        palette: {
            primary: {
                main: "#d1d0cc"
            }
        }
    });

    const classes = useStyles();
    const history = useHistory();
    const [pathname, setPathname] = useState(window.location.pathname);
    const pathsVisores = [`/client/${clientUUID}/visual/${Visor1UUID}`,`/client/${clientUUID}/visual/${Visor2UUID}`]

    const [sessionErrors, setSessionErrors] = useState(Array(2).fill(false));

    const [auth, setAuth] = useState(localStorage.getItem('auth-AlcaldiaBog'));
    const [accessToken, setAccessToken] = useState(localStorage.getItem('token-AlcaldiaBog'));
    const [username, setUsername] = useState(localStorage.getItem('username-AlcaldiaBog'));

    const validateSession = (username, password) => {
        let errorSesion = false;
        if (username === '') {
            errorSesion = true;
            sessionErrors[0] = true;
        }
        if (password === '') {
            errorSesion = true;
            sessionErrors[1] = true;
        }
        if (errorSesion) {
            setSessionErrors([...sessionErrors]);
            setMessage('Existen campos sin diligenciar o con algún error.');
            setSeverity('error');
            setTimeout(() => { setSnack(true) }, 0);
        }
        else {
            logIn(username, password);
        }
    }

    async function logIn(username, password) {
        setShowBackdrop(true);
        const res = await fetch(`${API_DEFAULT}/users/auth`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                'username': username,
                'password': password
            })
        })
        res
            .json()
            .then(d => {
                setShowBackdrop(false);
                if (d['token']) {
                    rol(d['token'], username);
                }
                else {
                    setMessage('Los datos de usuario y contraseña son incorrectos.');
                    setSeverity('error');
                    setTimeout(() => { setSnack(true) }, 0);
                }
            })
    }

    async function rol(token, usuario) {
        const res = await fetch(`${API_DEFAULT}/users/roles`, {
            headers: { 'Authorization': `Token ${token}` }
        })
        res
            .json()
            .then(d => {
                if (d['roles'].includes('Administrador') || d['roles'].includes('Visor AlcaldiaBog')) {
                    localStorage.setItem('token-AlcaldiaBog', token);
                    localStorage.setItem('auth-AlcaldiaBog', true);
                    localStorage.setItem('username-AlcaldiaBog', usuario);
                    setUsername(usuario);
                    setAccessToken(token);
                    setAuth(true);
                }
                else {
                    setMessage('El usuario no está habilitado para usar esta aplicación.');
                    setSeverity('warning');
                    setTimeout(() => { setSnack(true) }, 0);
                }
            })
    }

    const appBarCustom = (
        <AppBar position="static" style={{ marginBottom: theme.spacing(2), background: "linear-gradient(to right, #DA291C, #DA291C)" }}>
            <Toolbar>
                <div className={classes.logoSpacing}>
                    <a style={{ display: "contents" }} href={"https://www.centronacionaldeconsultoria.com/"}>
                        <img src={LogoCNC} alt="logo-cnc" className={classes.logo} />
                    </a>
                </div>
                <div className={classes.logoSpacing2}>
                    <a style={{ display: "contents" }} href={"https://www.ibague.gov.co/portal/index.php?srsltid=AfmBOopumtxAlgkIAsS3us_9Ar-Fzpd1-4hm3VAcaLu4LHz8wf426dpB"}>
                        <img src={LogoAlcaldiaIbague} alt="logo-AlcaldiaIbague" className={classes.logo2} />
                    </a>
                </div>
                <Typography variant="h5" style={{ flexGrow: 1, fontWeight: 500, color: "#ffffffff" }}>
                    Alcaldía de Ibagué
                </Typography>
                {auth ?
                    <React.Fragment>
                        <Typography className={classes.username} style={{ fontSize: 14, fontWeight: 500, marginRight: theme.spacing(2), fontStyle: "italic", color: "#ffffffff" }} variant='body1'>@{username.toLowerCase()}</Typography>
                        <IconButton edge='start' color='inherit' onClick={() => { localStorage.removeItem('token-AlcaldiaBog'); localStorage.removeItem('auth-AlcaldiaBog'); localStorage.removeItem('username-AlcaldiaBog'); setAccessToken(''); setAuth(false); setUsername(''); }}>
                            <LogoutIcon />
                        </IconButton>
                    </React.Fragment>
                    :
                    null
                }
            </Toolbar>
        </AppBar>
    );

    useEffect(() => {
        return history.listen((location) => {
            setPathname(location.pathname)
        })
    }, [history]);

    useEffect(() => {
        document.title = "Visualización CNC - Alcaldía de Bogotá"
    }, []);

    return (
        <ThemeProvider theme={actualTheme}>
            <Redirect
                to={{
                    pathname: !auth ?
                        `/client/${clientUUID}/login`
                        :
                        pathsVisores.includes(pathname) ?
                            pathname :
                            `/client/${clientUUID}/home`,
                    state: { from: props.location }
                }}
            />
            <Route exact path={`/client/${clientUUID}/login`}>
                {!auth ?
                    <React.Fragment>
                        {appBarCustom}
                        <Container maxWidth="xs">
                            <Sesion theme={theme} errors={[sessionErrors, setSessionErrors]} validateSession={validateSession} />
                        </Container>
                    </React.Fragment>
                    :
                    null
                }
            </Route>
            <Route exact path={`/client/${clientUUID}/home`}>
                {auth ? (
    <React.Fragment>
        {appBarCustom}
        <Container maxWidth="lg">
            <Grid container direction="row" alignItems="stretch" spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                    <Card style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                        <CardHeader
                            style={{ background: "linear-gradient(to right, #DA291C, #DA291C)", paddingTop: 12, paddingBottom: 12 }}
                            title={
                                <Typography variant="h6" style={{ fontSize: 21, color: "#ffffffff" }}>
                                    Uso del tiempo - personas
                                </Typography>
                            }
                        />
                        <Divider />
                        <CardContent style={{ padding: 8, display: "contents" }}>
                            <img src={ImgVisor1AlcaldiaIbague} alt="visor1-AlcaldiaIbague" />
                        </CardContent>
                        <CardActions style={{ justifyContent: "flex-end", paddingBottom: 12, paddingRight: 12 }}>
                            <ThemeProvider theme={responsiveFontSizes(buttonColor('#DA291C'))}>
                                <Button component={Link} variant="contained" size="small" to={`visual/${Visor1UUID}`}>
                                    Ir
                                </Button>
                            </ThemeProvider>
                        </CardActions>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <Card style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                        <CardHeader
                            style={{ background: "linear-gradient(to right, #DA291C, #DA291C)", paddingTop: 12, paddingBottom: 12 }}
                            title={
                                <Typography variant="h6" style={{ fontSize: 21, color: "#ffffffff" }}>
                                    Uso del tiempo - hogares
                                </Typography>
                            }
                        />
                        <Divider />
                        <CardContent style={{ padding: 8, display: "contents" }}>
                            <img src={ImgVisor2AlcaldiaIbague} alt="visor2-AlcaldiaIbague" />
                        </CardContent>
                        <CardActions style={{ justifyContent: "flex-end", paddingBottom: 12, paddingRight: 12 }}>
                            <ThemeProvider theme={responsiveFontSizes(buttonColor('#DA291C'))}>
                                <Button component={Link} variant="contained" size="small" to={`visual/${Visor2UUID}`}>
                                    Ir
                                </Button>
                            </ThemeProvider>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    </React.Fragment>
) : (
    <Redirect to={`/client/${clientUUID}/login`} />
)}

            </Route>
            <Route exact path={pathsVisores[0]}>
                {auth ?
                    <Visor1AlcaldiaIbague
                        theme={theme}
                        API_DEFAULT={API_DEFAULT}
                        accessToken={[accessToken, setAccessToken]}
                        setShowBackdrop={setShowBackdrop}
                        username={[username, setUsername]}
                        setAuth={setAuth}
                        clientUUID={clientUUID}
                    />
                    
                    :
                    <Redirect to={`/client/${clientUUID}/login`} />
                }
            </Route>
            <Route exact path={pathsVisores[1]}>
                {auth ?
                    <Visor2AlcaldiaIbague
                        theme={theme}
                        API_DEFAULT={API_DEFAULT}
                        accessToken={[accessToken, setAccessToken]}
                        setShowBackdrop={setShowBackdrop}
                        username={[username, setUsername]}
                        setAuth={setAuth}
                        clientUUID={clientUUID}
                    />
                    
                    :
                    <Redirect to={`/client/${clientUUID}/login`} />
                }
            </Route>
        </ThemeProvider>
    );
}